// webpack imports this file by ProvidePlugin
const { getSubAppConfig } = require("@cirrus/config")
window.$ = require("jquery") // Used by sowiso palette and mathjax

var App = new Marionette.Application()
App.mount = new Promise(function (resolve, reject) {
  App.on("mount", resolve)
})
App.Views = {}
App.Controllers = {}
App.Behaviors = {}

require("./backbone-ext/marionette.handlebars.webpack")
require("@cirrus/legacy/app-common/fonts") // todo concentrate all fonts inclusions in one file

var token = sessionStorage.getItem(getSubAppConfig().TokenKey)
$.ajaxSetup({
  headers: {
    Authorization: "Bearer " + token,
  },
})

module.exports = App

require("./handlebars/text-helpers")
require("./handlebars/avatar-helpers")
require("./handlebars/skin-helpers")
require("./handlebars/readspeaker-helpers")
require("./handlebars/utils-helpers")
require("./handlebars/utils-helpers.es6")

require("./extensions/jquery-lock")
